window.URL_API_NODEJS = process.env.VUE_APP_API_URL
